import { useState } from 'react';
import { Package } from 'lucide-react';

// La imagen de un producto donde quiera que aparezca: fila del catálogo,
// resultado de búsqueda, ficha del escáner.
//
// Nunca deja un hueco. Un producto sin foto muestra la inicial de su
// nombre sobre un fondo tranquilo — se lee como "todavía no tiene imagen",
// no como "algo falló al cargar", que es lo que comunica un rectángulo
// gris vacío. Y si la carga falla de verdad (una URL firmada que caducó
// mientras la pantalla estaba abierta), cae en el mismo sitio en vez de
// dejar el icono de imagen rota del navegador.
const TAMANOS = {
  sm: 'h-9 w-9 rounded-md text-[11px]',
  md: 'h-14 w-14 rounded-lg text-base',
  lg: 'h-28 w-28 rounded-xl text-2xl',
  xl: 'h-full w-full rounded-xl text-3xl',
};

export default function Miniatura({ src, nombre = '', tamano = 'sm', className = '' }) {
  const [fallo, setFallo] = useState(false);
  const clases = `${TAMANOS[tamano]} shrink-0 object-cover bg-gray-100 ${className}`;

  if (!src || fallo) {
    const inicial = nombre.trim().charAt(0).toUpperCase();
    return (
      <div
        className={`${clases} flex items-center justify-center border border-gray-200 text-gray-500 font-semibold`}
        aria-label={nombre ? `${nombre}, sin imagen` : 'Sin imagen'}
        title="Sin imagen"
      >
        {inicial || <Package className="h-1/2 w-1/2" />}
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={nombre}
      loading="lazy"
      onError={() => setFallo(true)}
      className={`${clases} border border-gray-200`}
    />
  );
}
